import React, { useCallback, useRef, useState } from 'react';
import { setBackgroundColor } from 'roosterjs-editor-api';
import styled from 'styled-components';
import { useFormatState, useToolbarActionContext } from '../context';
import { CommandButton } from './command-button';
import { IEditorToolbarActionBaseProps } from './types';
import { Callout } from '../../../callout';
import { ColorPicker } from '../../../color-picker';
import { selectThemeSemantics } from '../../../../styling';

const StyledColorPicker = styled(ColorPicker)`
    padding: ${selectThemeSemantics(({ gap }) => gap.l)};
`;

export function BackgroundColorAction(props: IEditorToolbarActionBaseProps) {
    const itemRef = useRef<HTMLSpanElement>(null);
    const [isCalloutHidden, setCalloutHiddenStatus] = useState(true);
    const { editor } = useToolbarActionContext();
    const { textColor: defaultTextColor } = editor.getDefaultFormat();
    const { textColor = defaultTextColor } = useFormatState();

    const _onValueChange = useCallback((value: string) => {
        setBackgroundColor(editor, value);
    }, [editor]);

    const showColorPicker = useCallback(() => {
        setCalloutHiddenStatus(false);
    }, []);

    const hideColorPicker = useCallback(() => {
        setCalloutHiddenStatus(true);
    }, []);

    return (
        <>
            <CommandButton {...props} tooltip="Background Color" iconName="ap-highlight.rte" elementRef={itemRef} onClick={showColorPicker} />
            <Callout offset={-5} hidden={isCalloutHidden} isBeakVisible targetRef={itemRef} onDismiss={hideColorPicker}>
                <StyledColorPicker defaultValue={textColor} onValueChange={_onValueChange} />
            </Callout>
        </>
    );
}
